import React from 'react';

const AboutUs = () => {
  return (
    <div className="bg-gray-900 min-h-screen text-white p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">About 502 Gold</h1>
        
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Our Story</h2>
          <p className="mb-4">
            502 Gold has established itself as a leading platform in the online Matka and Satta industry.
            With years of experience and a commitment to transparency, we provide our users with reliable
            and up-to-date information for all their gaming needs.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
          <p className="mb-4">
            Our mission is to provide a safe, secure, and transparent platform for Matka enthusiasts.
            We strive to deliver accurate results and maintain the highest standards of user experience
            while promoting responsible gaming practices.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Why Choose 502 Gold?</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Real-time result updates</li>
            <li>User-friendly interface</li>
            <li>24/7 customer support</li>
            <li>Secure and reliable platform</li>
            <li>Extensive game variety</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Our Commitment</h2>
          <p className="mb-4">
            We are committed to providing a responsible gaming environment. We implement strict
            age verification processes and promote responsible gaming practices. Our platform
            is designed to be transparent and fair for all users.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Contact Information</h2>
          <p className="mb-4">
            Have questions or need support? Reach out to us:<br />
            Email: support@502gold.com<br />
            Website: www.502gold.com<br />
            Operating Hours: 24/7
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Legal Compliance</h2>
          <p className="mb-4">
            502 Gold operates in full compliance with applicable laws and regulations.
            We maintain strict policies to ensure fair play and protect our users' interests.
            Gaming is restricted in regions where it is prohibited by law.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutUs; 